import { H5, H6 } from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const CriticalErrorHeader = styled(H5)``;
export const ErrorHeader = styled(H6)``;
export const ErrorMessage = styled(H6)``;
export const Root = styled.div`
	${({ theme }) => css`
		display: flex;
		flex-direction: column;
		position: absolute;
		top: 0;
		left: 0;
		align-items: center;
		height: 100%;
		width: 100%;
		background: ${theme.app.panels.overlayBackground};
		padding-top: 20%;

		${CriticalErrorHeader} {
			color: ${theme.colors.palette.grey[500]};
		}

		${ErrorHeader}, ${ErrorMessage} {
			color: ${theme.colors.palette.grey[600]};
		}
	`}
`;
